export const REACTION_SETS: {id: string, i18nKey: string, options: {id: string, emoji: string, i18nKey: string}[]}[] = [
    {
        id: "news",
        i18nKey: "liveblog.reactions.news.title",
        options: [
            { id: "applause", emoji: "👏", i18nKey: "liveblog.reactions.generic.applause" },
            { id: "surprising", emoji: "😮", i18nKey: "liveblog.reactions.generic.surprising" },
            { id: "insightful", emoji: "💡", i18nKey: "liveblog.reactions.generic.insightful" },
            { id: "touching", emoji: "💔", i18nKey: "liveblog.reactions.generic.touching" },
            { id: "important", emoji: "❗️", i18nKey: "liveblog.reactions.generic.important" },
            { id: "well_explained", emoji: "👍", i18nKey: "liveblog.reactions.generic.well_explained" }
        ]
    },
    {
        id: "sports",
        i18nKey: "liveblog.reactions.sports.title",
        options: [
            { id: "celebration", emoji: "🥳", i18nKey: "liveblog.reactions.generic.celebration" },
            { id: "thrilling", emoji: "😱", i18nKey: "liveblog.reactions.generic.thrilling" },
            { id: "frustration", emoji: "😤", i18nKey: "liveblog.reactions.generic.frustration" },
            { id: "applause", emoji: "👏", i18nKey: "liveblog.reactions.generic.applause" },
            { id: "support", emoji: "❤️", i18nKey: "liveblog.reactions.generic.support" },
            { id: "victory", emoji: "🏆", i18nKey: "liveblog.reactions.generic.victory" }
        ]
    },
    {
        id: "elections",
        i18nKey: "liveblog.reactions.elections.title",
        options: [
            { id: "important_topic", emoji: "🗳️", i18nKey: "liveblog.reactions.generic.important_topic" },
            { id: "sharp_view", emoji: "🧐", i18nKey: "liveblog.reactions.generic.sharp_view" },
            { id: "well_explained", emoji: "💡", i18nKey: "liveblog.reactions.generic.well_explained" },
            { id: "applause", emoji: "👏", i18nKey: "liveblog.reactions.generic.applause" },
            { id: "worth_reading", emoji: "🔍", i18nKey: "liveblog.reactions.generic.worth_reading" },
            { id: "by_the_numbers", emoji: "📊", i18nKey: "liveblog.reactions.generic.by_the_numbers" }
        ]
    },
    {
        id: "entertainment",
        i18nKey: "liveblog.reactions.entertainment.title",
        options: [
            { id: "lovely", emoji: "😍", i18nKey: "liveblog.reactions.generic.lovely" },
            { id: "party", emoji: "🥳", i18nKey: "liveblog.reactions.generic.party" },
            { id: "hilarious", emoji: "😂", i18nKey: "liveblog.reactions.generic.hilarious" },
            { id: "mind_blown", emoji: "🤯", i18nKey: "liveblog.reactions.generic.mind_blown" },
            { id: "epic", emoji: "🔥", i18nKey: "liveblog.reactions.generic.epic" },
            { id: "applause", emoji: "👏", i18nKey: "liveblog.reactions.generic.applause" }
        ]
    }
];
